import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/ui/Loading';
import QueryBox from '../../components/query/QueryBox';
import { sendQuestion } from '../../services/query';
import Banner from '../../components/ui/Banner';
import { PROGRESS_DURATION } from '../../constants/common';
import { HistoryContext } from '../../context/HistoryContext';
import Promotion from '../../components/marketing/promotion';

const QueryIndexPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { refreshHistory } = useContext(HistoryContext);
	const [showLoading, setShowLoading] = useState(false);
	const [id, setId] = useState(null);
	const [error, setError] = useState(null);

	document.title = `${t('general.app_name')} Ai`;

	const handleSubmit = async (message) => {
		setShowLoading(true);
		try {
			const data = await sendQuestion(message);
			if (data.conversationId) {
				setId(data.conversationId);
				refreshHistory();
			} else {
				setError(data.error);
				toast.error(t('error.could_not_load_answer'));
				setShowLoading(false);
			}
		} catch (error) {
			console.error('Error sending question:', error);
			setShowLoading(false);
		}
	};

	const handleLoadingComplete = () => {
		navigate(`/query/${id}`);
		setShowLoading(false);
	};

	if (showLoading) {
		return (
			<Loading
				onComplete={handleLoadingComplete}
				completed={id !== null}
				progressDuration={PROGRESS_DURATION}
				messages={[
					'loading.analyzing_question',
					'loading.retrieving_references',
					'loading.evaluating_relevance',
					'loading.extracting_key_points',
					'loading.formulating_response',
				]}
			/>
		);
	}

	return (
		<div className='flex flex-col justify-center items-center p-8 gap-8'>
			<div className='flex justify-center overflow-visible'>
				<div className='relative inline-block'>
					<img src='/images/Socrates_ikon.png' alt='Socrates illustration' className='max-h-80' />
					<div className='absolute left-full top-0 ml-2'>
						<Promotion />
					</div>
				</div>
			</div>
			<div className='flex flex-col items-center gap-[10px]  max-w-2xl'>
				<h1 className='text-[38px] text-on-secondary text-center'>
					{t('main_page.title', { app_name: t('general.app_name') })}
				</h1>
				<p className='text-on-tertiary-active text-center'>
					{t('main_page.subtext', { app_name: t('general.app_name') })}
				</p>
			</div>
			<QueryBox onSubmit={handleSubmit} />
			{error && <Banner label={t('query.error')} variant='warning' className='mb-4' />}
			{/* <div className='flex flex-row gap-4'>
				<Button size='medium' type='line'>
					{t('main_page.button1')}
				</Button>
				<Button size='medium' type='line'>
					{t('main_page.button2')}
				</Button>
				<Button size='medium' type='line'>
					{t('main_page.button3')}
				</Button>
			</div> */}
		</div>
	);
};

export default QueryIndexPage;
